/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Commons_Error_NetworkInputs */

const de_commons_error_network = /** @type {(inputs: Commons_Error_NetworkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Netzwerkfehler - bitte Verbindung prüfen`)
};

/** @type {(inputs: Commons_Error_NetworkInputs) => LocalizedString} */
const en_commons_error_network = de_commons_error_network;

/**

* @param {Commons_Error_NetworkInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const commons_error_network = /** @type {((inputs?: Commons_Error_NetworkInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Commons_Error_NetworkInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_commons_error_network(inputs)
	return en_commons_error_network(inputs)
});